import { render, staticRenderFns } from "./RenewPassword.vue?vue&type=template&id=63c7d697&scoped=true"
import script from "./RenewPassword.vue?vue&type=script&lang=js"
export * from "./RenewPassword.vue?vue&type=script&lang=js"
import style0 from "./RenewPassword.vue?vue&type=style&index=0&id=63c7d697&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c7d697",
  null
  
)

export default component.exports